import React from "react";

import "./index.scss";

const SquareRadioButton = ({ type = "square", isSelected, onChange, label , className}) => {
    const detectTheme = () => {
        return JSON.parse(localStorage.getItem("theme_config")) ? JSON.parse(localStorage.getItem("theme_config")).theme : "light"
    }
    return (
        <div className={`radio-container ${className ? className : ""} ${detectTheme()}`}>
            <div className="radio-wrapper">
                <input
                    type="radio"
                    id={type}
                    name="custom-radio"
                    // defaultChecked={isSelected}
                    checked={isSelected}
                    onChange={() => { }}
                    onClick={() => { }}
                />
                <label className={`square`} onClick={(e) => {
                    onChange(!isSelected)

                }}>
                    {isSelected && <span className="check-mark" ></span>}
                </label>
            </div>
            <label className="square-label">
                {label}
            </label>
        </div>
    );
};

export default SquareRadioButton;
